/*  ========================================================================
    # Hooks - Use Breakpoints
    ========================================================================  */

import { useEffect, useState } from 'react';
import defaultTheme from 'tailwindcss/defaultTheme';

/**
 * Hook to get the current viewport width and check if it matches the breakpoints.
 */
const useBreakpoints = () => {
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const handleResize = () => setViewportWidth(window.innerWidth);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [window, handleResize]);

  return {
    sm: viewportWidth >= parseInt(defaultTheme.screens.sm, 10),
    md: viewportWidth >= parseInt(defaultTheme.screens.md, 10),
    lg: viewportWidth >= parseInt(defaultTheme.screens.lg, 10),
    xl: viewportWidth >= parseInt(defaultTheme.screens.xl, 10),
    xxl: viewportWidth >= parseInt(defaultTheme.screens['2xl'], 10)
  };
};

export default useBreakpoints;
